import { useState, type FormEvent } from 'react';
import { ArrowRight, Eye, EyeSlash, LockKey, User } from '@phosphor-icons/react';
import type { Session } from './types';
import { ApiError, request, setCsrfToken } from './api';
import { BrandMark, Button, Field } from './components';

export function LoginPage({ onLogin }: { onLogin: (session: Session) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const session = await request<Session>('/api/v1/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password })
      });
      setCsrfToken(session.csrfToken);
      onLogin(session);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : '登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-story" aria-hidden="true">
        <BrandMark />
        <div className="login-story__content">
          <p className="eyebrow">经销商专属订货通道</p>
          <h1>规格清楚，<br />下单一步到位。</h1>
          <p>从系列、口径到销售单位，每一项订购信息都准确留档。</p>
        </div>
        <div className="pipe-drawing"><i /><i /><i /><b /></div>
        <p className="login-story__foot">商品价格与订货信息仅向授权经销商开放</p>
      </section>

      <section className="login-panel">
        <div className="login-panel__mobile-brand"><BrandMark /></div>
        <form className="login-card" onSubmit={submit}>
          <div className="login-card__title">
            <span className="login-card__index">01</span>
            <div><h2>登录订货</h2><p>请使用公司分配的经销商或内部账号</p></div>
          </div>
          {error && <div className="inline-error" role="alert">{error}</div>}
          <Field label="账号">
            <span className="input-with-icon"><User /><input autoFocus autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} placeholder="请输入登录账号" required /></span>
          </Field>
          <Field label="密码">
            <span className="input-with-icon"><LockKey /><input type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="请输入密码" required /><button type="button" onClick={() => setShowPassword((value) => !value)} aria-label={showPassword ? '隐藏密码' : '显示密码'}>{showPassword ? <EyeSlash /> : <Eye />}</button></span>
          </Field>
          <Button type="submit" loading={loading} className="login-submit">进入订货系统 <ArrowRight weight="bold" /></Button>
          <p className="login-help">无法登录？请联系龙杰业务人员重置账号密码。</p>
        </form>
        <p className="login-legal">阳江龙杰日丰订货系统 · 封闭式经销商业务系统</p>
      </section>
    </main>
  );
}
